import {PayloadAction, createSlice} from "@reduxjs/toolkit";
import {AxiosError} from "axios";
import {ErrorDto} from "../../../types/ErrorDto";

export interface ErrorState {
  errors: ErrorDto[];
}

export interface ReceivedError {
  error: AxiosError | Error;
  message?: string;
}

const initialState: ErrorState = {
  errors: [],
};

export const errorSlice = createSlice({
  name: "error",
  initialState,
  reducers: {
    receiveError(state, action: PayloadAction<ReceivedError>) {
      const receivedError = action.payload;
      const genericError = receivedError.error as Error;

      const errorDto: ErrorDto = {
        message: genericError.message || "An unexpected error occurred",
        statusCode: 0,
        statusText: "",
      };

      state.errors.push(errorDto);
    },

    receiveAxiosError(state, action: PayloadAction<ReceivedError>) {
      const receivedError = action.payload;
      const axiosError = receivedError.error as AxiosError;

      let message = receivedError.message || "";
      let errorDto: ErrorDto;

      if (axiosError.response) {
        if (!message) {
          const method = axiosError.response.config.method;
          const url = axiosError.response.config.url;

          if (method && url) {
            message = `Cannot ${method.toUpperCase()} ${url}`;
          }
        }

        errorDto = {
          message,
          statusCode: axiosError.response.status,
          statusText: axiosError.response.statusText,
        };

        state.errors.push(errorDto);
      }

      if (axiosError.request && !axiosError.response) {
        errorDto = {
          message: "An error with no response occurred",
          statusCode: axiosError.request.status,
          statusText: axiosError.request.statusText,
        };

        state.errors.push(errorDto);
      } else if (!axiosError.request && !axiosError.response) {
        errorDto = {
          message: "An unexpected Axios error occurred",
          statusCode: 0,
          statusText: "",
        };
        state.errors.push(errorDto);
      }
    },
    removeError(state, action: PayloadAction<number>) {
      state.errors.splice(action.payload, 1);
    },
    clearErrors() {
      return initialState;
    },
  },
});

export const {receiveAxiosError, receiveError, clearErrors, removeError} = errorSlice.actions;
